module.exports = __webpack_public_path__ + "static/media/app-store-nb.fb752197.svg";